(function () {
  try {
    if (window.__tvCartCodeInit) return;
    window.__tvCartCodeInit = true;

    var WCKEY = 'tv:scwc';

    function wc() {
      try {
        var r = JSON.parse(localStorage.getItem(WCKEY) || 'null');
        if (!r || !r.code || !r.endsAt) return null;
        return r;
      } catch (e) { return null; }
    }

    function fmtLeft(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      if (d > 0) return d + 'd ' + h + 'h';
      if (h > 0) return h + 'h ' + m + 'm';
      return m + 'm ' + (s % 60) + 's';
    }

    function bind(el) {
      if (el.__tvCcBound) return;
      el.__tvCcBound = true;
      var tpl = el.getAttribute('data-tpl') || 'Your [pct]% code [code] expires in [time]';
      var timer = null;

      function hide() { el.hidden = true; el.textContent = ''; }
      function schedule() {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!el.isConnected) return;
        var rec = wc();
        if (!rec) { hide(); return; }
        var left = rec.endsAt - Date.now();
        if (left <= 0) { hide(); return; }
        var txt = tpl
          .replace('[pct]', String(rec.pct || 15))
          .replace('[code]', String(rec.code))
          .replace('[time]', fmtLeft(left));
        if (el.textContent !== txt) el.textContent = txt;
        el.hidden = false;
        timer = setTimeout(schedule, left < 3600000 ? 1000 : 30000);
      }
      el.__tvCcKick = schedule;
      schedule();
    }

    function scan() {
      var list = document.querySelectorAll('[data-tv-cart-code]');
      for (var i = 0; i < list.length; i++) bind(list[i]);
    }

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); }, 200);
    });

    function start() {
      scan();
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      var list = document.querySelectorAll('[data-tv-cart-code]');
      for (var i = 0; i < list.length; i++) if (list[i].__tvCcKick) list[i].__tvCcKick();
    });
  } catch (e) { }
})();
